import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Auth runs as an app initializer (see appConfig), so it completes before the router starts
// and before the first render — no route can be evaluated while auth is still pending.
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
